import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { TabView, TabPanel } from 'primereact/tabview';
import { getDatosCliente } from "../../../../service/AffariService";

const DeudaDialog = ({ visible, onCancel, codigo }) => {
    const [deudas, setDeudas] = useState({ vencidas: [], vigentes: [] });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (visible && codigo) {
            setLoading(true);
            setDeudas({ vencidas: [], vigentes: [] });
            getDatosCliente(codigo)
                .then((resp) => {
                    setDeudas({
                        vencidas: Array.isArray(resp?.deudas?.vencidas) ? resp.deudas.vencidas : [],
                        vigentes: Array.isArray(resp?.deudas?.vigentes) ? resp.deudas.vigentes : [],
                    });
                })
                .catch((error) => {
                    console.error("Error fetching debt data:", error);
                })
                .finally(() => setLoading(false));
        }
    }, [visible, codigo]);

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(value);
    };

    const calculateTotal = (items) => {
        if (!items) return 0;
        return items.reduce((acc, item) => acc + (item.saldo || 0), 0);
    };

    const footer = (items) => {
        return (
            <div className="flex justify-content-start font-bold">
                Total: {formatCurrency(calculateTotal(items))}
            </div>
        );
    };

    const renderTable = (items) => {
        return (
            <DataTable 
                value={items} 
                emptyMessage="No se encontraron deudas." 
                showGridlines 
                stripedRows
                footer={footer(items)}
                size="small"
                scrollable
                scrollHeight="400px"
            >
                <Column header="#" body={(data, options) => options.rowIndex + 1} style={{ width: '3rem' }} />
                <Column field="tipo" header="Tipo" />
                <Column field="numero" header="Numero" />
                <Column field="vendedor" header="Vendedor" />
                <Column field="fecha" header="Fecha" />
                <Column field="saldo" header="Saldo" body={(rowData) => formatCurrency(rowData.saldo)} />
                <Column field="dias" header="Dias" />
            </DataTable>
        );
    }

    return (
        <Dialog
            header={`Deuda Cliente`}
            visible={visible}
            className="p-fluid custom-dialog"
            modal
            onHide={onCancel}
            dismissableMask={true}
        >
            {loading ? (
                <div className="flex justify-content-center">
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                </div>
            ) : (
                <TabView>
                    <TabPanel header="Vencidos">
                        {renderTable(deudas.vencidas)}
                    </TabPanel>
                    <TabPanel header="Vigentes">
                        {renderTable(deudas.vigentes)}
                    </TabPanel>
                </TabView>
            )}
        </Dialog>
    );
};

export default DeudaDialog;
